/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { MemoryResponseData } from "./MemoryResponseData";

/**
 * Response schema for Memory GET endpoint
 */
export interface MemoryResponse {
  id: string;
  user_id: string;
  conversation_id?: string | null;
  type: string;
  data: MemoryResponseData;
  source_conversation_ids?: string[] | null;
  patient_edited?: boolean;
  created_at: string;
  updated_at: string;
}
